import ImgNavigationBar from './img-navigation-bar';

export default ImgNavigationBar;
